import { Injectable } from '@angular/core';
import {BaseService, httpOptions} from "@core/service/base.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderDetailService extends BaseService{
  private url = 'api/purOrderDetail';
  private deleteOrderDetailBatch = 'api/purOrderDetail/batch/delete';//订单明细批量删除
  private deleteOrderDetail = 'api/purOrderDetail/delete';//订单明细单独删除
  private syncUrl = 'api/purOrder/sync';//从erp同步数据
  constructor(http: HttpClient) {
    super(http);
  }
  getUrl(): string {
    return this.url;
  }

  //从erp同步数据
  syncData(object):Observable<any> {
    return this.http.post<any>(this.syncUrl, object, httpOptions).pipe(
      tap((object: any) => this.log(`syncData`)),
      catchError(this.handleError<any>('syncData'))
    );
  }

//  批量删除订单明细
  orderDetailBatchDelete(ids:any[]):Observable<any> {
    return this.http.post<any>(this.deleteOrderDetailBatch,ids).pipe(
      tap(_ => this.log(`deleted object list id=${ids}`)),
      catchError(this.handleError<any>('delet object list'))
    );
  }

//  单独删除订单明细
  orderDetailDeletd(params):Observable<any> {
    return this.http.get<any>(this.deleteOrderDetail, {
      headers:httpOptions.headers,
      observe: 'response',//完整数据返回，包括抬头,
      params:params
    }).pipe(
      tap(_ => this.log(`deleted object `)),
      catchError(this.handleError<any>('deleteany'))
    );
  }
}
